__turbopack_context__.v({
  "actionButton": "layout-module-scss-module__pyx1wa__actionButton",
  "dotsPattern": "layout-module-scss-module__pyx1wa__dotsPattern",
  "footerCol": "layout-module-scss-module__pyx1wa__footerCol",
  "footerContent": "layout-module-scss-module__pyx1wa__footerContent",
  "footerPattern": "layout-module-scss-module__pyx1wa__footerPattern",
  "landingHomeContainer": "layout-module-scss-module__pyx1wa__landingHomeContainer",
  "landingPageContainer": "layout-module-scss-module__pyx1wa__landingPageContainer",
  "mailLink": "layout-module-scss-module__pyx1wa__mailLink",
  "mdContainer": "layout-module-scss-module__pyx1wa__mdContainer",
  "mobileMenu": "layout-module-scss-module__pyx1wa__mobileMenu",
  "pricingGreenDiagonal": "layout-module-scss-module__pyx1wa__pricingGreenDiagonal",
  "scheduleGreenDiagonal": "layout-module-scss-module__pyx1wa__scheduleGreenDiagonal",
  "secondaryBtn": "layout-module-scss-module__pyx1wa__secondaryBtn",
  "sectionDescription": "layout-module-scss-module__pyx1wa__sectionDescription",
  "sectionTitle": "layout-module-scss-module__pyx1wa__sectionTitle",
  "staticPageContainer": "layout-module-scss-module__pyx1wa__staticPageContainer",
  "staticPageHeaderSubTitle": "layout-module-scss-module__pyx1wa__staticPageHeaderSubTitle",
  "staticPageHeaderTitle": "layout-module-scss-module__pyx1wa__staticPageHeaderTitle",
  "staticPageHeaderWrapper": "layout-module-scss-module__pyx1wa__staticPageHeaderWrapper",
});
